import { NullableDropdownItem, DropdownItem, DropdownGroup } from '../types';
import { filterNullableDropdownItems, isDropdownGroup } from '../helpers';
import { useState, useMemo } from 'react';

function match(
  item: DropdownItem | false | null | undefined,
  searchQuery: string
): DropdownItem | false {
  if (!item) {
    return false;
  }
  if (isDropdownGroup(item)) {
    const filteredItems = searchFilter(item.items, searchQuery);
    if (filteredItems.length > 0) {
      return { ...item, items: filteredItems } as DropdownGroup;
    }
  } else if (typeof item.label === 'string' && item.label.includes(searchQuery)) {
    return item;
  }

  return false;
}

function searchFilter(items: DropdownItem[], searchQuery: string) {
  if (!searchQuery) {
    return items;
  }

  return items.map(item => match(item, searchQuery)).filter(item => !!item) as DropdownItem[];
}

// This hook does basic sanitization of items, filtering out falsy options,
// and optionally allows further filtering for search
export function useDropdownItems(items: NullableDropdownItem[]) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredItems = useMemo(
    () => searchFilter(filterNullableDropdownItems(items), searchQuery),
    [items, searchQuery]
  );

  return {
    filteredItems,
    setSearchQuery,
  };
}
